import {Component, EventEmitter, Input, Output} from '@angular/core';
export class PromptHeaderComponent {

     modal: boolean = false;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'prompt-header',
    template: `
        <div [class.modal-header]="modal">
            <div [class.form-group]="!modal">
                <ng-content></ng-content>
            </div>
        </div>
    `
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'modal': [{ type: Input },],
};
}

function PromptHeaderComponent_tsickle_Closure_declarations() {
/** @type {?} */
PromptHeaderComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PromptHeaderComponent.ctorParameters;
/** @type {?} */
PromptHeaderComponent.propDecorators;
/** @type {?} */
PromptHeaderComponent.prototype.modal;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
